import { PropTypes } from 'base/react-libs';
import { Icon } from '@evertrue/et-components';

const JourneyFavoriteToggle = ({ journey = {}, onClick = () => {} }) => {
  const isFavorited = journey?.favorite || false;
  return (
    <Icon
      icon={isFavorited ? 'favorite-icon-filled' : 'favorite-star'}
      iconKit="gt2"
      className={isFavorited ? `favorited favorite-star` : `favorite-star`}
      onClick={() => {
        onClick(journey);
      }}
    />
  );
};

JourneyFavoriteToggle.propTypes = {
  journey: PropTypes.object,
  onClick: PropTypes.func,
};

export default JourneyFavoriteToggle;
